@if (node && treeNodeService) {
  @if (showActionButtons() === true) {
    <div
      class="action-buttons"
      [class.block-buttons]="isMoveActive() && !isThisNodeMoved()"
      [class.block-buttons-move]="isMoveActive()"
    >
      <!--    <button *ngIf="!isEndType(node.item_type_id)"-->
      @if (showAddButton()) {
        <button
          class="tree-action-button"
          (click)="addButtonClicked()"
          [attr.data-cy]="node.item_name + '-add'"
          data-cy="tree-action-add-button"
        >
          <mat-icon svgIcon="add"></mat-icon>
        </button>
      }
      @if (showEditButton()) {
        <button
          class="tree-action-button editTreeItem"
          (click)="editButtonClicked()"
          [attr.data-cy]="node.item_name + '-edit'"
        >
          <mat-icon svgIcon="edit" color="primary"></mat-icon>
        </button>
      }
      @if (showMoveButton()) {
        <button
          [attr.data-cy]="node.item_name + '-move'"
          class="tree-action-button moveTreeItem"
          (click)="moveButtonClicked()"
        >
          <mat-icon>{{ !isMoveActive() ? 'drag_handle' : 'close' }}</mat-icon>
        </button>
      }
      @if (showDeleteButton()) {
        <button
          class="tree-action-button deleteTreeItem"
          [disabled]="blockDeleteButton()"
          (click)="deleteButtonClicked()"
          [attr.data-cy]="node.item_name + '-delete'"
        >
          <mat-icon svgIcon="delete"></mat-icon>
        </button>
      }
    </div>
  }
}
